import { graphql } from 'gatsby';
import React from 'react';
import EmailForm, { EmailFormProps } from 'components/form/EmailForm';

export type FormBlockProps = {
  referenced_email_form: {
    destination: string;
    email_form_template: [{ form_structure: EmailFormProps }];
  };
};

const ReferencedEmailFormBlock: React.FC<FormBlockProps> = ({
  referenced_email_form,
}) => {
  const { email_form_template, destination } = referenced_email_form;
  return (
    <EmailForm {...email_form_template[0].form_structure} destination={destination} />
  );
};

export const query = graphql`
  fragment ReferencedEmailFormBlock on cs__referenced_email_form {
    destination
    email_form_template {
      ...EmailFormTemplate
    }
  }
`;

export default ReferencedEmailFormBlock;
